import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const initialState = {
  profile: null,
  isFetching: false,
  isError: false,
  errorMessage: "",
  isAuthenticated: false,
  isPurchaseCompleted: false,
};

export const getAvatarProfile = createAsyncThunk(
  "avatar/details",
  async (data, { rejectWithValue, extra }) => {
    try {
      const avatarRepository = extra.avatarRepository;
      const avatarKey = data.avatarKey;
      const avatarId = data.avatarId;
      console.log("Avatar Data", data);
      console.log("Avatar Key", avatarKey);
      console.log("Avatar Id", avatarId);
      if (avatarKey) {
        let result = await avatarRepository.getAvatarDetailsByKey(avatarKey);
        if (result.success) {
          return result.data;
        }
      } else if (avatarId) {
        let result = await avatarRepository.getAvatarDetailsById(avatarId);
        if (result.success) {
          return result.data;
        }
      }
      return rejectWithValue(
        { message: "Failed to fetch avatar details." }
      );
    } catch (error) {
      console.error("Avatar fetch error:", error);
      return rejectWithValue(
        error.response?.data || { message: "Failed to fetch avatar details." }
      );
    }
  }
);

export const createModelProfileSlice = (avatarRepository) => {
  return createSlice({
    name: "modelProfile",
    initialState,
    reducers: {
      resetProfile: (state, action) => {
        state.profile = initialState.profile;
      },
      setIsFetching: (state, actions) => {
        state.isFetching = actions.payload;
      },
      resetIsError: (state, action) => {
        state.isError = false;
        state.errorMessage = "";
      },
      setIsAuthenticated: (state, actions) => {
        state.isAuthenticated = actions.payload;
      },
      setIsPurchaseCompleted: (state, actions) => {
        state.isPurchaseCompleted = actions.payload;
      },
    },
    extraReducers: (builder) => {
      builder
        .addCase(getAvatarProfile.pending, (state, action) => {
          state.isFetching = true;
          state.profile = null;
          state.isError = false;
          state.errorMessage = "";
        })
        .addCase(getAvatarProfile.fulfilled, (state, action) => {
          state.isFetching = false;
          state.profile = action.payload;
          state.isError = false;
          state.errorMessage = "";
        })
        .addCase(getAvatarProfile.rejected, (state, action) => {
          state.isFetching = false;
          state.isError = true;
          state.profile = null;
          state.errorMessage =
            action.payload?.message || "Failed to fetch avatar details.";
        });
    },
  });
};
